import React from 'react';
export const ReactionConfigContext = React.createContext(undefined);
//# sourceMappingURL=reaction-config-context.js.map